import Main from 'layouts/main';
import cn from 'classnames';
import s from './style.css';
import Helmet from 'utils/helmet';

const Page = ({ title, children, large, full }) => (
	<Main fullSize={full}>
		{title && <Helmet title={`${title} – Faces of Energy`} />}
		{!title && <Helmet title={'Faces of Energy'} />}
		<div className={cn(s.wrapper, { [s.large]: large, [s.tight]: full })}>
			{title && <h2 className={s.title}>{title}</h2>}
			{children && (
				<div className={s.content} key={title}>
					{children}
				</div>
			)}
		</div>
	</Main>
);

export default Page;



// WEBPACK FOOTER //
// ./components/pageWrap/index.js